import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Pencil, Save, X as XIcon } from "lucide-react";
import { API } from "../../lib/auth";

const inputCls = "w-full bg-[#0E2452] border border-[#2F568F] text-white px-4 py-2.5 rounded-xl focus:outline-none focus:border-[#FF5A00]";
const labelCls = "text-[10px] uppercase tracking-widest text-white/40 font-display block mb-1";

export const ProfileEditor = ({ user, setUser }) => {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState("");
  const [telefone, setTelefone] = useState("");
  const [saving, setSaving] = useState(false);

  const start = () => {
    setName(user?.name || "");
    setTelefone(user?.telefone || "");
    setEditing(true);
  };

  const save = async () => {
    if (name.trim().length < 2) {
      toast.error("O nome deve ter pelo menos 2 caracteres.");
      return;
    }
    setSaving(true);
    try {
      const { data } = await axios.patch(`${API}/auth/me`, { name: name.trim(), telefone: telefone.trim() }, { withCredentials: true });
      setUser({ ...user, name: data.name, telefone: data.telefone });
      toast.success("Perfil atualizado");
      setEditing(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Não foi possível guardar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section data-testid="profile-editor" className="rounded-2xl border border-[#2F568F] bg-[#0B1D44] p-5 md:p-6 mb-6">
      <div className="flex items-center justify-between gap-3 mb-4">
        <div>
          <div className="section-label mb-1">// Perfil</div>
          <h2 className="font-display font-bold uppercase text-white text-lg">Os seus dados</h2>
        </div>
        {!editing ? (
          <button data-testid="edit-profile-btn" onClick={start} className="inline-flex items-center gap-2 border border-[#2F568F] hover:border-[#FF5A00] text-white/80 hover:text-white font-body text-sm px-3 py-2 rounded-full transition-all">
            <Pencil className="w-3.5 h-3.5" /> Editar
          </button>
        ) : (
          <div className="flex gap-2">
            <button data-testid="cancel-profile-btn" onClick={() => setEditing(false)} disabled={saving} className="inline-flex items-center gap-2 border border-[#2F568F] text-white/80 hover:text-white font-body text-sm px-3 py-2 rounded-full transition-all disabled:opacity-50">
              <XIcon className="w-3.5 h-3.5" /> Cancelar
            </button>
            <button data-testid="save-profile-btn" onClick={save} disabled={saving} className="inline-flex items-center gap-2 bg-[#FF5A00] hover:bg-[#E65100] text-white font-display font-bold uppercase text-[11px] tracking-wider px-3 py-2 rounded-full transition-all disabled:opacity-50">
              <Save className="w-3.5 h-3.5" /> Guardar
            </button>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className={labelCls}>Nome</label>
          {editing ? (
            <input data-testid="edit-name-input" type="text" value={name} onChange={(e) => setName(e.target.value)} className={inputCls} />
          ) : (
            <div className="text-white font-body text-base">{user.name || "—"}</div>
          )}
        </div>
        <div>
          <label className={labelCls}>Telefone</label>
          {editing ? (
            <input data-testid="edit-phone-input" type="tel" value={telefone} onChange={(e) => setTelefone(e.target.value)} placeholder="+351 9xx xxx xxx" className={inputCls} />
          ) : (
            <div className="text-white font-body text-base">{user.telefone || <span className="text-white/40 italic">Não indicado</span>}</div>
          )}
        </div>
        <div className="md:col-span-2">
          <label className={labelCls}>Email</label>
          <div className="text-white/70 font-body text-sm">{user.email} <span className="text-[10px] text-white/30">· não editável</span></div>
        </div>
      </div>
    </section>
  );
};

export default ProfileEditor;
